var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.display)?_c('div',{staticClass:"tooltip_warn"},[_c('div',{staticClass:"tooltip_warn_close",on:{"click":_vm.close}},[_vm._v("x")]),_vm._v("\n\tДля данного вида мероприятий возможен ввод только целочисленных значений\n")]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7e1d0a29","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/edit/fetch_data/tooltipWarn.vue
// module id = uc+W
// module chunks = 0